import React from 'react';
import CatalogoPage from '../components/CatalogoPage';

export function ClientesPage() {
  return (
    <CatalogoPage
      title="Clientes"
      endpoint="/catalogos/clientes"
      description="Empresas de transporte monitoreadas"
      fields={[
        { key:'nombre', label:'Nombre / Razón Social', required:true, placeholder:'Transportes S.A. de C.V.' },
        { key:'rfc', label:'RFC', placeholder:'TSA200101AAA' },
        { key:'contacto', label:'Nombre del Contacto', placeholder:'Juan Pérez' },
        { key:'telefono', label:'Teléfono', type:'tel', placeholder:'55-1234-5678' },
        { key:'email', label:'Correo Electrónico', type:'email', placeholder:'contacto@empresa.com' },
        { key:'direccion', label:'Dirección', type:'textarea', placeholder:'Calle, Ciudad, Estado' },
        { key:'notas', label:'Notas', type:'textarea' },
        { key:'activo', label:'Activo', type:'checkbox', default:true }
      ]}
    />
  );
}

export default ClientesPage;
